import { connect } from 'react-redux';
import React, { PropTypes } from 'react';

import PageSelector from 'components/PageSelector';
import { getCommentsPaging } from 'selectors';
import * as actions from 'actions';

export const ResourceCommentsPageSelector = props => {
  const { resourceId, resourceType, ...otherProps } = props; //eslint-disable-line no-unused-vars
  return <PageSelector {...otherProps} />;
};

ResourceCommentsPageSelector.propTypes = {
  resourceId: PropTypes.number,
  resourceType: PropTypes.string,
  sort: PropTypes.string,
  pageSize: PropTypes.number
};

const queryForProps = props => ({resourceId: props.resourceId, resourceType: props.resourceType, sort: props.sort});

const mapStateToProps = (state, props) => {
  const queryString = JSON.stringify(queryForProps(props));
  return getCommentsPaging(state, null, { queryString });
};

const mapDispatchToProps = (dispatch, props) => {
  const query = queryForProps(props);

  return {
    onPrevClick: currentPage => {
      dispatch(actions.commentsFetch(currentPage - 1, props.pageSize, query));
    },
    onNextClick: currentPage => {
      dispatch(actions.commentsFetch(currentPage + 1, props.pageSize, query));
    },
    onPossiblePageUpdate: newPossiblePage => {
      dispatch(actions.commentsUpdatePossiblePage(newPossiblePage, query));
    },
    onPageUpdate: (newPage, pagesCount) => {
      if(newPage >= 1 && newPage <= pagesCount) {
        dispatch(actions.commentsFetch(newPage, props.pageSize, query));
      }
    }
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ResourceCommentsPageSelector);



/** WEBPACK FOOTER **
 ** ./src/members/Main/__shared__/containers/ResourceCommentsPageSelector/index.js
 **/